import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { routeTree } from './routeTree.gen';
import { ThemeProvider } from './lib/theme';
import { initSentry } from './lib/sentry';
import { RecoveryFallback } from './components/recovery-fallback';
import { Toaster } from './components/toaster';
import { createGlobalErrorQueryClient } from './lib/query-client';
import './index.css';

initSentry();

const queryClient = createGlobalErrorQueryClient();

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<RecoveryFallback />}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster />
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
